import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import Money from 'js-money';

const LANGUAGES_WITHOUT_SYMBOL_CURRENCY = ['ua', 'ru'];

export class CurrencySelect extends Component {
    static get propTypes() {
        return {
            type: PropTypes.string,
            label: PropTypes.string,
            value: PropTypes.string,
            currencies: PropTypes.array,
            onChange: PropTypes.func,
            useFullName: PropTypes.bool,
        }
    }

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        const {name, value} = e.target;

        this.setState({value});
        this.props.onChange(value, name);
    }

    /** @private */
    _renderOptionsTemplate(currencies) {
        const shouldUseSymbol = !this.props.useFullName && !LANGUAGES_WITHOUT_SYMBOL_CURRENCY.includes(window.language);
        return currencies.map((currency) => {
            const { symbol } = Money[currency] || { symbol: currency };
            return (
                <MenuItem key={currency} value={currency}>
                    {this.props.useFullName && <i className={`flag-icon flag-icon-squared flag-icon-${currency.toLowerCase().substr(0, 2)}`} />}
                    {shouldUseSymbol ? symbol : currency}
                </MenuItem>
            );
        });
    }

    render() {
        const {currencies, value, type} = this.props;
        const options = this._renderOptionsTemplate(currencies);

        return value && (
            <form>
                <FormControl>
                    <InputLabel htmlFor={type}/>
                    <Select
                        name={type}
                        value={value}
                        onChange={this.handleChange}>
                        {options}
                    </Select>
                </FormControl>
            </form>
        )
    }
}
